<template>
  <hm-content title="促销详情">
    <div class="detail-container">
      <div class="mb20">
        <el-radio-group v-model="groupStatus" size="small" @change="switchTabs">
          <el-radio-button :label="v" v-for="(v, i) in grouList" :key="i">{{
            v.promotionName
          }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="activity mb20">
        <div class="caption">
          创建促销
        </div>
        <ul>
          <li class="flex">
            <div class="title">促销活动</div>
            <div class="content">
              {{ details.basicConfigInfo.promotionName }}
            </div>
          </li>
          <li class="flex">
            <div class="title">基础价&nbsp;&nbsp;&nbsp;</div>
            <div class="content">
              <span
                v-show="details.basicConfigInfo.assignPriceType === 'promotion'"
                >会员价</span
              >
              <span
                v-show="details.basicConfigInfo.assignPriceType === 'retail'"
                >零售价</span
              >
            </div>
          </li>
          <li
            class="flex"
            v-if="details.basicConfigInfo.runningTimeType === 'all'"
          >
            <div class="title">优惠时间</div>
            <div class="content primary" v-if="details.pasCalendars">
              {{ details.pasCalendars.promotionStartTime }}至{{
                details.pasCalendars.promotionEndTime
              }}
            </div>
          </li>
          <li
            class="flex"
            v-if="details.basicConfigInfo.runningTimeType === 'special'"
          >
            <div class="title">优惠时间</div>
            <div class="content primary">
              {{ details.dateConfigInfo.promotionStartDate }}至{{
                details.dateConfigInfo.promotionEndDate
              }}
            </div>
          </li>
          <li
            class="flex"
            v-if="details.basicConfigInfo.runningTimeType === 'special'"
          >
            <div class="title">特定时段</div>
            <div>
              <div
                class="content primary"
                v-if="details.dateConfigInfo.dateType === 'day'"
              >
                <div>每{{ details.dateConfigInfo.dateValue }}天生效</div>
              </div>
              <div class="content primary">
                <div
                  class="flex"
                  v-if="details.dateConfigInfo.dateType === 'week'"
                >
                  每
                  <div
                    class="mr10"
                    v-for="(v, i) in details.dateConfigInfo.dateValues"
                    :key="i"
                  >
                    {{ "周" + v }}
                  </div>
                  生效
                </div>
                <div
                  class="flex"
                  v-if="details.dateConfigInfo.dateType === 'month'"
                >
                  每月
                  <div
                    class="mr10"
                    v-for="(v, i) in details.dateConfigInfo.dateValues"
                    :key="i"
                  >
                    {{ v }}
                  </div>
                  日生效
                </div>
                <div v-for="(v, i) in details.dateConfigRange" :key="i">
                  {{ v.promotionStartTime }} 至 {{ v.promotionEndTime }}
                </div>
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">参与门店</div>
            <div class="content">
              <!-- <div
                v-if="
                  details.pasOutlets.length === 1 &&
                    details.pasOutlets[0].outletId === '0'
                "
              >
                全部门店
              </div> -->
              <div v-for="(v, i) in details.pasOutlets" :key="i">
                {{ v.outletName }}
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">销售渠道</div>
            <div class="content">
              <div v-for="(v, i) in details.platformModels" :key="i">
                {{ v.platformName }}
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">促销标签</div>
            <div class="content flex">
              <el-tag v-for="(v, i) in details.pasLabels" :key="i"
                >{{ v.labelKey }}
              </el-tag>
            </div>
          </li>
          <li class="flex">
            <div class="title">会员群组</div>
            <div class="content">
              <!-- <div
                v-if="
                  details.memberGroupList.length === 1 &&
                    details.memberGroupList[0].groupId === '0'
                "
              >
                全部会员群组
              </div> -->
              <div v-for="(v, i) in details.memberGroupList" :key="i">
                {{ v.groupName }}
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="goods mb20" v-if="details.pasGoods.length">
        <div class="caption">
          选择商品
        </div>
        <el-table
          border
          :data="details.pasGoods"
          style="width: 100%"
          id="table"
          size="small"
          :row-class-name="tableRowClassNames"
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="attrId"
            label="商品货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="attrValue"
            label="商品名称"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <span
                v-if="scope.row.useable === 'white' || !scope.row.useable"
                class="select-type white"
                >白</span
              >
              <span
                v-if="scope.row.useable === 'black'"
                class="select-type black"
                >黑</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="rule  mb20">
        <div class="caption">
          创建规则
        </div>
        <ul>
          <li class="flex">
            <div class="title" style="width: 56px">促销类型</div>
            <!-- 满减 -->
            <div
              class="content"
              v-if="
                details.fullReductionRule && details.fullReductionRule.length
              "
            >
              <div
                v-for="(v, i) in details.fullReductionRule"
                :key="i"
                class="flex"
              >
                <div class="mr10">
                  每买满
                  <span class="primary">{{ v.calcCondition }}</span>
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumReduction'
                    "
                    >件</span
                  >
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceReduction'
                    "
                    >元</span
                  >
                </div>
                <div class="mr10">
                  减<span class="primary">{{ v.discountResult }}</span
                  >元
                </div>
                <div>
                  最多循环<span class="primary">{{ v.cyclesTimes }}</span
                  >次
                </div>
              </div>
            </div>
            <!-- 满折 -->
            <div
              class="content"
              v-if="details.fullDiscountRule && details.fullDiscountRule.length"
            >
              <div>
                <span v-show="discountMode === 'floorPriceDiscount'"
                  >最低价打折</span
                >
                <span v-show="discountMode === 'fullPriceDiscount'"
                  >整单打折</span
                >
              </div>
              <div v-for="(v, i) in details.fullDiscountRule" :key="i">
                <div class="mr10">
                  每买满<span class="primary">{{ v.purchasesAmount }}</span>
                  <span
                    class="mr10"
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumDiscount'
                    "
                    >件</span
                  >
                  <span
                    class="mr10"
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceDiscount'
                    "
                    >元</span
                  >
                  <span v-show="discountMode === 'floorPriceDiscount'"
                    >最低价商品</span
                  >打<span class="primary">{{ v.discountRatio }}</span
                  >折
                </div>
              </div>
            </div>
            <!-- 满送 -->
            <div class="content flex-1" v-if="details.fullDeliveryRule">
              <div class="flex">
                <div class="mr10">
                  捆绑方式<span class="primary">{{
                    details.fullDeliveryRule.selectType === "mix"
                      ? "混合"
                      : "同品"
                  }}</span>
                </div>
                <div class="mr10">
                  赠送商品价格<span
                    class="primary"
                    v-show="details.giftLimit === 'yes'"
                    >买高送低</span
                  >
                  <span class="primary" v-show="details.giftLimit === 'no'"
                    >不限</span
                  >
                </div>
                <!-- 赠送同品模式 -->
                <div class="mr10">
                  每买满<span class="primary"
                    >{{ details.fullDeliveryRule.purchasesAmount }}
                  </span>
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumDelivery'
                    "
                    >件</span
                  >
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceDelivery'
                    "
                    >元</span
                  >
                </div>
                <div
                  class="flex"
                  v-if="details.fullDeliveryRule.selectType === 'same'"
                >
                  <div class="mr10">
                    <!-- 送必选商品<span class="primary">{{details.fullDeliveryRule.mustDeliveryAmount}}</span>件 -->
                    送必选同品如下
                  </div>
                  <div>
                    送可选商品<span class="primary">{{
                      details.selectLowerLimit
                    }}</span
                    >件
                  </div>
                </div>
              </div>
              <!-- 赠送同品模式 -->
              <div v-if="details.fullDeliveryRule.selectType === 'same'">
                <el-table
                  :data="details.deleveryGoods"
                  style="width: 100%"
                  id="table"
                  border
                  size="small"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    label="商品货号"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsPackageNum"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="selectUpperLimit"
                    label="赠送上限"
                  ></el-table-column>
                  <!-- <el-table-column header-align="center"
                                   align="center"
                                   prop="isMustDelivery"
                                   label="状态">
                    <template slot-scope="scope">
                      <span class="success"
                            v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                      <span class="danger"
                            v-show="scope.row.isMustDelivery === 'no'">可选</span>
                    </template>
                  </el-table-column> -->
                </el-table>
              </div>
              <!-- 赠送混合模式 -->
              <div v-if="details.fullDeliveryRule.selectType === 'mix'">
                <div v-for="(v, i) in details.fullDeliveryGoods" :key="i">
                  <div class="mb20 flex">
                    <div>
                      <span v-if="i > 0">加</span>送可选商品<span
                        class="primary"
                        >{{ v.selectLowerLimit }}</span
                      >件
                    </div>
                  </div>
                  <el-table
                    :data="v.groupGoods"
                    style="width: 100%"
                    id="table"
                    border
                    size="small"
                    :row-class-name="tableRowClassName"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsSn"
                      label="商品货号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsName"
                      label="商品名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPackageNum"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="selectUpperLimit"
                      label="赠送上限"
                    ></el-table-column>
                    <!-- <el-table-column header-align="center"
                                    align="center"
                                    prop="isMustDelivery"
                                    label="状态">
                      <template slot-scope="scope">
                        <span class="success"
                              v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                        <span class="danger"
                              v-show="scope.row.isMustDelivery === 'no'">可选</span>
                      </template>
                    </el-table-column> -->
                  </el-table>
                </div>
              </div>
            </div>
            <!-- 加价购 -->
            <div class="content flex-1" v-if="details.increasePurchaseRules">
              <div
                class="mb20"
                v-for="(v, i) in details.increasePurchaseRules"
                :key="i"
              >
                <div class="flex mb20">
                  <div class="item mr20">
                    每买满 <span class="primary">{{ v.purchasesAmount }}</span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'NumIncrease'
                      "
                    >
                      件
                    </span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'PriceIncrease'
                      "
                    >
                      元
                    </span>
                  </div>
                  <div class="item mr20">
                    加<span class="primary">{{ v.markupFee }}</span
                    >元
                  </div>
                  <div class="item mr20 flex item-center">
                    换购<span class="primary">{{
                      v.exchangePurchasesUpperAmount
                    }}</span
                    >件
                  </div>
                </div>
                <!-- 加价购赠送商品 -->
                <el-table
                  :data="v.purchaseGoodsList"
                  size="mini"
                  border
                  :row-class-name="tableRowClassName"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="goodsSn"
                    header-align="center"
                    align="center"
                    label="货号"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goodsName"
                    header-align="center"
                    align="center"
                    label="商品名"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goodsPackageNum"
                    header-align="center"
                    align="center"
                    label="商品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="selectUpperLimit"
                    header-align="center"
                    align="center"
                    label="换购上限"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 组合价 -->
            <div class="content flex-1" v-if="details.combinationPriceGoods">
              <div
                class="flex mb20"
                v-for="(v, i) in details.combinationPriceRules"
                :key="i"
              >
                <div class="item mr20">
                  每买满 <span class="primary">{{ v.purchasesAmount }}</span
                  >件
                </div>
                <div class="item mr20">
                  组合价<span class="primary">{{ v.combinationPrice }}</span
                  >元
                </div>
              </div>
              <el-table
                :data="details.combinationPriceGoods"
                size="mini"
                :row-class-name="tableRowClassName"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="goodsSn"
                  header-align="center"
                  align="center"
                  label="货号"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsName"
                  header-align="center"
                  align="center"
                  label="商品名"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsPackageNum"
                  header-align="center"
                  align="center"
                  label="商品数量"
                >
                </el-table-column>
                <el-table-column
                  prop="selectUpperLimit"
                  header-align="center"
                  align="center"
                  label="换购上限"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 特价 -->
            <div class="content flex-1" v-if="details.listHot">
              <el-table
                :data="details.listHot"
                size="mini"
                :row-class-name="tableRowClassName"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="goodsSn"
                  header-align="center"
                  align="center"
                  label="货号"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsName"
                  header-align="center"
                  align="center"
                  label="商品名"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsPackageNum"
                  header-align="center"
                  align="center"
                  label="商品数量"
                >
                </el-table-column>
                <el-table-column
                  prop="shopPrice"
                  header-align="center"
                  align="center"
                  label="商品价格"
                >
                </el-table-column>
                <el-table-column
                  prop="totalStockNum"
                  header-align="center"
                  align="center"
                  label="促销库存"
                >
                </el-table-column>
                <el-table-column
                  prop="purchasesUpperLimit"
                  header-align="center"
                  align="center"
                  label="促销上限"
                >
                </el-table-column>
                <el-table-column
                  prop="discountRatio"
                  header-align="center"
                  align="center"
                  label="折扣比率"
                >
                </el-table-column>
                <el-table-column
                  prop="discountPrice"
                  header-align="center"
                  align="center"
                  label="折扣金额"
                >
                </el-table-column>
              </el-table>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-wrapper flex flex-center">
      <!-- <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('audit_pass')"
        >通过</el-button
      >
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('reject')"
        >驳回</el-button
      > -->
      <el-button size="small" @click="back">返回</el-button>
    </div>
    <!-- <el-dialog
      title="驳回当前促销?"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form label-width="80px">
        <el-form-item label="驳回原因">
          <el-input
            maxlength="100"
            size="small"
            type="textarea"
            v-model="reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitRuleForm" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog> -->
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      reason: "",
      mode: "",
      dialogVisible: false,
      previewDiaogVisible: false,
      keyWord: "",
      discountMode: "",
      storeOutletId: "",
      serverId: "",
      status: "",
      currentPage: 1,
      startDate: "",
      endDate: "",
      dateAndTime: "",
      pageSize: 10,
      isWaitAudit: false,
      id: "",
      btnList: [
        { name: "全部" },
        { name: "已预约" },
        { name: "已付款" },
        { name: "消费中" },
        { name: "服务结束" },
        { name: "取消预约" },
        { name: "已驳回" }
      ],
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: []
      },
      groupStatus: "",
      grouList: [],
      goodsSn: ""
    };
  },
  async mounted() {
    const {
      type,
      id,
      parentId,
      mode,
      wxshopSkuId,
      goodsSn
    } = this.$route.query;
    this.id = id;
    this.mode = mode;
    this.goodsSn = goodsSn;
    this.isWaitAudit = type === "wait_audit";
    const { result } = await this.$store.dispatch("queryGoodsActiveDetail", {
      wxshopSkuId: wxshopSkuId
    });
    this.grouList = result;
    this.groupStatus = result[0];

    switch (parentId) {
      case "FullDiscount":
        this.$store.dispatch("queryFullDiscountDetails", {
          id,
          parentId
        });
        break;
      case "FullReduction":
        this.$store.dispatch("queryFullReductionDetails", {
          id,
          parentId
        });
        break;
      case "FullDelivery":
        this.$store.dispatch("queryFullDelivertDetails", {
          id,
          parentId
        });
        break;
      case "IncreasePurchase":
        this.$store.dispatch("queryIncreasePurchaseDetails", {
          id,
          parentId
        });
        break;
      case "CombinationPrice":
        this.$store.dispatch("queryCombinationDetails", {
          id,
          parentId
        });
        break;
      case "SpecialPrice":
        this.$store.dispatch("querySpecialRuleDetails", {
          id,
          parentId
        });
        break;
      default:
        break;
    }
  },
  computed: mapGetters([
    "fullDiscountDetails",
    "fullReductionDetails",
    "fullDeliveruDetails",
    "selectType",
    "fullIncreasePurchaseDetails",
    "combinationDetails",
    "specialRuleDetails"
  ]),
  watch: {
    specialRuleDetails(val) {
      this.details = val;
    },
    fullDiscountDetails(val) {
      this.details = val;
      this.details.fullDiscountRule.map(v => {
        this.discountMode = v.discountMode;
      });
    },
    fullReductionDetails(val) {
      this.details = val;
    },
    fullDeliveruDetails(val) {
      if (this.selectType === "same") {
        val.deleveryGoods = [];
        val.selectLowerLimit = val.fullDeliveryGoods[1]
          ? val.fullDeliveryGoods[1].selectLowerLimit
          : 0;
        val.giftLimit = val.fullDeliveryGoods[0]
          ? val.fullDeliveryGoods[0].giftLimit
          : "yes";
        val.fullDeliveryGoods.map(o => {
          val.deleveryGoods = val.deleveryGoods.concat(o.groupGoods);
        });
        this.details = val;
      } else if (this.selectType === "mix") {
        val.giftLimit = val.fullDeliveryGoods[0]
          ? val.fullDeliveryGoods[0].giftLimit
          : "yes";
        val.fullDeliveryGoods.forEach(v => {
          v.groupGoods.forEach(o => {
            if (o.typeId && o.typeValue) {
              o.goodsSn = o.typeId;
              o.goodsName = o.typeValue;
            }
          });
        });
        this.details = val;
      }
    },
    fullIncreasePurchaseDetails(val) {
      this.details = val;
    },
    combinationDetails(val) {
      this.details = val;
    }
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.goodsSn === this.goodsSn) {
        return "tuikuan";
      }
      return "";
    },
    tableRowClassNames({ row }) {
      if (row.attrId === this.goodsSn) {
        return "tuikuan";
      }
      return "";
    },
    async switchTabs() {
      const { type, id, parentId } = this.groupStatus;
      this.id = id;
      this.isWaitAudit = type === "wait_audit";
      switch (parentId) {
        case "FullDiscount":
          this.$store.dispatch("queryFullDiscountDetails", {
            id,
            parentId
          });
          break;
        case "FullReduction":
          this.$store.dispatch("queryFullReductionDetails", {
            id,
            parentId
          });
          break;
        case "FullDelivery":
          this.$store.dispatch("queryFullDelivertDetails", {
            id,
            parentId
          });
          break;
        case "IncreasePurchase":
          this.$store.dispatch("queryIncreasePurchaseDetails", {
            id,
            parentId
          });
          break;
        case "CombinationPrice":
          this.$store.dispatch("queryCombinationDetails", {
            id,
            parentId
          });
          break;
        case "SpecialPrice":
          this.$store.dispatch("querySpecialRuleDetails", {
            id,
            parentId
          });
          break;
        default:
          break;
      }
    },
    submitRuleForm() {
      this.$store
        .dispatch("switchAuditState", {
          id: this.id,
          auditState: "reject",
          reason: this.reason
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.$router.back(-1);
          }
        });
    },
    switchAuditState(auditState) {
      if (auditState === "reject") {
        this.dialogVisible = true;
      } else {
        this.$store
          .dispatch("switchAuditState", {
            id: this.id,
            auditState
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
      }
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}

.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
}
</style>
